export const state = () => ({
	prospects: null,
});

export const mutations = {
	setProspects(state: any, payload: any) {
		state.prospects = payload;
	},
};

export const getters = {
	getProspects: (state: any) => state.prospects,
};

export const actions = {
	getAllProspects(state: any, payload: any) {
		const company = state.rootState.auth.user.company.uuid;
		const { url, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.get(url || `/api/company/${company}/prospects`, {
					params: data,
				})
				.then((res) => {
					state.commit('setProspects', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	createProspect(state: any, payload: any) {
		const company = state.rootState.auth.user.company.uuid;
		const url = `/api/company/${company}/prospects`;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(url, payload)
				.then((res) => {
					state.commit('applications/setApplicantProspectUuid', res.data.uuid, { root: true });

					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	deleteProspect(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete(`/api/company/prospects/${payload}`)
				.then((res) => {
					state.commit('applications/setApplicantProspectUuid', null, { root: true });

					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},
};
